import React from 'react';

const MunicipalityImage = ({ imageUrl, alt }) => {
  return <img alt={alt} className="municipalityImage" src={imageUrl} />;
};

export { MunicipalityImage };
